import { ISubAccountData } from "@/store/SubAccountStore";
import { TextButton } from "@/pages/child-customer/atom";
import { Fragment, useState } from "react";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { Input, Modal } from "@renderbus/ui";
import request from "project-config/services/request/request";
import styled from "styled-components";
import PathPattern from "@/pages/child-customer/view/child-manage/components/child-operation/components/hide-asset-button/service/manage-path-patterns";
import { Form } from "@renderbus/ui";
import { PlusOutlined } from "@ant-design/icons";
import { Radio } from "antd";
import { message } from "antd";
import useForm from "antd/es/form/hooks/useForm";

import Garbage1 from "@/assets/images/Garbage-1.png";
import Garbage2 from "@/assets/images/Garbage-2.png";

// import { Tooltip } from "@renderbus/ui/components/tooltip";
import { ToolTip } from "task-eva-ui";

const demonstration = [
  {
    title: "property_path_patterns_demonstration1",
    pattern: "/*/foo/*",
    match: ["/src/foo/bar.js"],
    instead: ["/src/bar.js", "src/foo2/bar.js", "/src/foo/test/"],
  },
  {
    title: "property_path_patterns_demonstration2",
    pattern: "/src/foo/**",
    match: ["/src/foo/bar.js", "/src/foo/ui/bar.js", "src/foo/test/"],
    instead: ["/src/bar.js", "/src/bar/foo/bar.js"],
  },
  {
    title: "property_path_patterns_demonstration3",
    pattern: "/src/foo/*bar*.js",
    match: [
      "/src/foo/bar.js",
      "/src/foo/bar1.js",
      "/src/foo/bar123.js",
      "/src/foo/123bar123.js",
    ],
    instead: ["/src/bar.js", "/src/foo/ui/bar.js"],
  },
];

export interface IPathPatterns {
  sharePattern?: string[];
  hidePattern?: string[];
}

export function HiadeAssetButton(row: ISubAccountData) {
  const t = getTranslateNsT("center");
  const commonT = getTranslateNsT("common");
  const { id, subUserName } = row;
  const [open, setOpen] = useState(false);
  const [isShare, setIsShare] = useState(false);
  const [current, setCurrent] = useState("sharePattern");
  const [currentData, setCurrentData] = useState([""]);
  const [pathPattern, setPathPattern] = useState<IPathPatterns>();
  const [form] = useForm<IPathPatterns>();
  async function onOpen() {
    const { data } = await request.post(
      "/api/rendering/file/operate/queryPathPatterns",
      {
        userId: id,
      }
    );
    const _propertyPathPatterns = new PathPattern(data);
    setPathPattern({
      sharePattern: [..._propertyPathPatterns.sharePattern],
      hidePattern: [..._propertyPathPatterns.hidePattern],
    });
    changeCurrent(_propertyPathPatterns.isShare, _propertyPathPatterns);
    setOpen(true);
  }
  function changeCurrent(
    isShare: boolean,
    _propertyPathPatterns?: PathPattern
  ) {
    const _current = isShare ? "sharePattern" : "hidePattern";
    const _currentData = pathPattern
      ? pathPattern[_current as keyof IPathPatterns] || []
      : _propertyPathPatterns
      ? _propertyPathPatterns[_current as keyof IPathPatterns]
      : [];
    form.setFieldValue(_current, _currentData);
    setIsShare(isShare);
    setCurrent(_current);
    setCurrentData(_currentData);
  }
  function handleSubmit() {
    form.validateFields().then(async () => {
      const patterns = form.getFieldValue(current).filter((i: any) => i);
      const res = await request.post(
        "/api/rendering/file/operate/createSubUserPathPatterns",
        {
          patterns,
          userId: id,
          useName: subUserName,
          type: Number(isShare),
        }
      );
      if (res.code === 200) {
        message.success(commonT("save_success"));
      } else {
        message.error(commonT("save_fail"));
      }
      setPathPattern({
        sharePattern: pathPattern?.sharePattern,
        hidePattern: pathPattern?.hidePattern,
        [current]: [...patterns, ""],
      });
      setOpen(false);
    });
  }

  return (
    <Fragment>
      <ToolTip
        content={t("user_com_childManage_del_render_btn_hideProperty_tip")}
        trigger="hover"
        hidden={Boolean(row["shareMainCapital"])}
      >
        <TextButton
          type="text"
          onClick={onOpen}
          disabled={!row["shareMainCapital"]}
        >
          {t("user_com_childManage_del_render_btn_hideProperty")}
        </TextButton>
      </ToolTip>
      <ModalParent>
        <Modal
          open={open}
          title={t("user_com_childManage_del_render_btn_hideProperty")}
          width={1000}
          className="re_modal"
          destroyOnClose={true}
          children={
            <>
              <HideAssetWrapper>
                <OperationWrapper>
                  <SelectRadio>
                    <Radio.Group
                      buttonStyle="outline"
                      value={isShare}
                      onChange={(event: any) => {
                        changeCurrent(event.target.value);
                      }}
                    >
                      <Radio value={false}>
                        {t("user_com_childManage_del_render_btn_hideAssets")}
                      </Radio>
                      <Radio value={true}>
                        {t("user_com_childManage_del_render_btn_shareAssets")}
                      </Radio>
                    </Radio.Group>
                  </SelectRadio>
                  <Form form={form} autoComplete="off" preserve={false}>
                    <Form.List
                      name={current}
                      initialValue={
                        current === "sharePattern" ? currentData : ["", ""]
                      }
                    >
                      {(fields, { add, remove }) => {
                        const _fields = [...fields];
                        if (!_fields.length) {
                          _fields.push({
                            fieldKey: 0,
                            key: 0,
                            name: 0,
                          });
                        }
                        return (
                          <>
                            {_fields.map((field, index) => (
                              <InputWrapper key={field.key}>
                                <Form.Item
                                  {...field}
                                  name={[field.name]}
                                  shouldUpdate
                                  rules={[
                                    {
                                      max: 200,
                                      message: t(
                                        "property_path_patterns_error"
                                      ),
                                    },
                                  ]}
                                >
                                  <Input placeholder={"*/foo/*"} />
                                </Form.Item>
                                {index >= 1 ? (
                                  <Garbage
                                    onClick={() => remove(field.name)}
                                  ></Garbage>
                                ) : (
                                  <></>
                                )}
                              </InputWrapper>
                            ))}
                            <Form.Item>
                              <div className="add_path" onClick={() => add()}>
                                <PlusOutlined />
                                <span>
                                  {t(
                                    "user_com_childManage_del_render_btn_addPath"
                                  )}
                                </span>
                              </div>
                            </Form.Item>
                          </>
                        );
                      }}
                    </Form.List>
                  </Form>
                </OperationWrapper>
                <InputRuleWrapper>
                  <div className="tips">{t("property_path_patterns_tips")}</div>
                  <p>{t("user_com_childManage_del_render_btn_applyRules")}</p>
                  <div className="rule" style={{ paddingLeft: "15px" }}>
                    <span className="one">*</span>
                    <span>{t("property_path_patterns_rules_content1")}</span>
                  </div>
                  <div className="rule" style={{ paddingLeft: "15px" }}>
                    <span className="one">**</span>
                    <span>{t("property_path_patterns_rules_content2")}</span>
                  </div>
                  {demonstration.map((item) => (
                    <div key={item.title}>
                      <div className="tips">{t(`${item.title}`)}</div>
                      <table>
                        <thead>
                          <tr>
                            <th>{t("property_path_patterns_th1")}</th>
                            <th>{t("property_path_patterns_th2")}</th>
                            <th>{t("property_path_patterns_th3")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{item.pattern}</td>
                            <td>
                              {item.match.map((match) => (
                                <p key={match}>{match}</p>
                              ))}
                            </td>
                            <td>
                              {item.instead.map((instead) => (
                                <p key={instead}>{instead}</p>
                              ))}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  ))}
                </InputRuleWrapper>
              </HideAssetWrapper>
              <OperationButton>
                <div className="button" onClick={() => setOpen(false)}>
                  {t("user_com_childManage_del_render_btn_cancel")}
                </div>
                <div className="button" onClick={handleSubmit}>
                  {t("property_path_patterns_btn_apply")}
                </div>
              </OperationButton>
            </>
          }
          footer={null}
          onCancel={(close) => setOpen(false)}
        />
      </ModalParent>
    </Fragment>
  );
}

const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  input {
    max-width: 440px;
    border: 1px solid #2c2c31 !important;
    border-radius: 4px !important;
    height: 36px;
    background-color: #2c2c31 !important;
  }
  input:focus {
    border: 1px solid var(--main-color) !important;
  }
  > div {
    flex: 1;
  }
  span {
    margin-bottom: 20px;
    font-size: 20px;
    margin-left: 20px;
    cursor: pointer;
  }
`;
const HideAssetWrapper = styled.div`
  display: flex;
`;

const InputRuleWrapper = styled.div`
  width: max-content;
  padding: 0 30px 30px 30px;
  font-size: 12px;
  border-top: 1px solid #43454d;
  flex: 1;
  .rule {
    display: flex;
    justify-content: flex-start;
    padding-left: 30px;
    margin-bottom: 2px;
    background-color: #26272b;
    height: 36px;
    border-radius: 4px;
    line-height: 36px;
    color: #aab6be;
    span {
      text-align: left;
    }
    .one {
      flex-basis: 40px;
      flex-grow: 0;
    }
  }
  .tips {
    max-width: 400px;
    margin: 20px 0;
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    th {
      padding: 10px;
      text-align: center;
      background-color: #26272b;
      color: #aab6be;
      border-bottom: 1px solid #43454d;
    }
    td {
      background-color: #26272b;
      color: #aab6be;
      padding: 10px 10px 0 10px;
      text-align: center;
      p {
        text-align: center;
        margin-bottom: 10px;
      }
    }
  }
`;
const OperationWrapper = styled.div`
  flex-basis: 534px;
  padding: 0 30px 30px 30px;
  font-size: 12px;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #43454d;
  border-top: 1px solid #43454d;
  .add_path {
    max-width: 440px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #545760;
    cursor: pointer;
    > span {
      padding-left: 4px;
    }
  }
  .add_path:hover {
    border: 1px solid var(--main-color);
    color: var(--main-color);
  }
  .add_path:active {
    background-color: #26272b;
    border: 1px solid var(--main-color);
    color: var(--main-color);
  }
  .ant-form-item {
    max-width: 440px;
  }
`;
const SelectRadio = styled.div`
  margin-top: 30px;
  margin-bottom: 30px;
  .ant-radio-wrapper .ant-radio-checked .ant-radio-inner {
    background-color: var(--main-color);
    border-color: var(--main-color);
  }
  .ant-radio-wrapper:hover .ant-radio-inner {
    border-color: var(--main-color);
  }
`;
const ModalParent = styled.div``;
const OperationButton = styled.div`
  width: 100%;
  border-top: 1px solid #434343;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  .button {
    width: 100px;
    height: 40px;
    border-radius: 4px;
    background-color: var(--main-color);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  & > .button:nth-child(1) {
    margin-right: 20px;
    background-color: #5c5d5f;
  }
`;
export const Garbage = styled.span`
  flex-basis: 40px;
  height: 40px;
  border-radius: 4px;
  background-color: #26272a;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    width: 20px;
    height: 20px;
    background-image: url(${Garbage1});
    background-size: 100% 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  :hover {
    ::before {
      background-image: url(${Garbage2});
    }
  }
`;
